export default "__VITE_ASSET__DdNd4Evb__"